/**
 * Single launcher for the Deadlock Analyzer tab, shared by the command palette,
 * the main toolbar and the MSSQL connection context menu. No connection is
 * required; when one is passed the tab opens in collector mode
 * (`sourceKind: 'connection'`) reading that connection's system_health session.
 */
import { useWorkspaceStore } from '../core/store/workspaceStore';
import type { TabConnectionInfo } from '../core/types/workspaceTypes';

/** `from-connection` = an open import tab switched to collector mode through the toolbar picker. */
export type DeadlockAnalyzerEntryPoint = 'toolbar' | 'command-palette' | 'context-menu' | 'from-connection';

export const DEADLOCK_ANALYZER_TAB_TITLE = 'Deadlock Analyzer';

export function openDeadlockAnalyzerTab(args: { entry: DeadlockAnalyzerEntryPoint; connectionInfo?: TabConnectionInfo }): string {
  const { entry, connectionInfo } = args;
  const title = connectionInfo?.connectionName
    ? `${DEADLOCK_ANALYZER_TAB_TITLE}: ${connectionInfo.connectionName}`
    : DEADLOCK_ANALYZER_TAB_TITLE;
  const tabId = useWorkspaceStore.getState().addTab({
    title,
    type: 'deadlock-analyzer',
    connectionInfo,
    content: connectionInfo?.connectionId
      ? { sourceKind: 'connection', connectionId: connectionInfo.connectionId, collectorRange: { kind: 'last24h' } }
      : { sourceKind: 'none' },
  });
  window.electronAPI?.analytics?.track('feature:deadlock_analyzer_open', { entry }).catch(() => {
    /* fire-and-forget */
  });
  return tabId;
}
